export interface HomeProps {}

export const SupportTemplate: React.FC<HomeProps> = (props: HomeProps) => {
  return (
    <>
      <div className="xl:max-w-7xl mx-auto flex flex-col lg:flex-row relative px-6 py-32 xsm:py-8 sm:py-12 lg:py-24 border-b">
        <div className="div1 w-full md:ml-2 lg:w-2/3 mx-auto max-w-2xl">
          <div className="mb-8 flex justify-left">
            <img
              className="max-w-[50px] lg:w-[100px] text-left"
              src={require("../../assets/Guac_Horizontal_Logo.png")}
              alt="Guac Horizontal Logo"
            />
          </div>
          <div className="w-4/5 text-left">
            <ul className="flex mt-6">
              <li className="max-w-[50px] mr-4">
                <a
                  href="https://www.instagram.com/guacapp.savings/"
                  aria-label="Visit GuacApp on Instagram"
                >
                  <img
                    src={require("../../assets/instagram.svg").default}
                    alt="Instagram logo"
                  />
                </a>
              </li>
              <li className="max-w-[50px] mr-4">
                <a
                  href="https://www.linkedin.com/company/99296795/admin/dashboard/"
                  aria-label="Visit GuacApp on LinkedIn"
                >
                  <img
                    src={require("../../assets/linkedin.svg").default}
                    alt="LinkedIn logo"
                  />
                </a>
              </li>
              <li className="max-w-[50px] mr-4">
                <a
                  href="https://www.facebook.com/guacapp.savings"
                  aria-label="Visit GuacApp on Facebook"
                >
                  <img
                    src={require("../../assets/facebook.svg").default}
                    alt="Facebook logo"
                  />
                </a>
              </li>
              <li className="max-w-[50px] mr-4">
                <a
                  href="https://x.com/guacappsavings"
                  aria-label="Visit GuacApp on X"
                >
                  <img
                    src={require("../../assets/twitter.svg").default}
                    alt="Twitter logo"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="div3 mx-auto max-w-2xl text-center mt-5">
        <div className="flex flex-col lg:flex-row justify-center lg:justify-evenly items-center">
          <p className="mt-6 lg:mt-0 text-sm leading-8 text-gray-600">
            <a
              target="_blank"
              href="https://guac-docs.s3.us-west-2.amazonaws.com/Guac_TermsConditions.pdf"
              aria-label="View Privacy Policy"
            >
              Terms & Conditions
            </a>
          </p>
          <p className="mt-6 lg:mt-0 text-sm leading-8 text-gray-600">
            <a href="/privacy-policy" aria-label="View Privacy Policy">
              Privacy Policy
            </a>
          </p>
          <p className="mt-6 lg:mt-0 text-sm leading-8 text-gray-600">
            <a href="/faq" aria-label="Visit Support Page">
              Support
            </a>
          </p>
          <p className="mt-6 lg:mt-0 text-sm leading-8 text-gray-600">
            <a href="/faq" aria-label="View FAQ">
              FAQ
            </a>
          </p>
        </div>
        <p className="mt-6 text-sm leading-8 text-gray-600">
          All rights reserved. For full details, see Guac's Terms and Conditions
          and Privacy Policy. Guac does not hold customer funds. Guac is a
          financial technology company, not a bank. Guac is not FDIC-insured.
          FDIC insurance only covers the failure of an insured bank.
          Pass-through insurance coverage is subject to conditions. By utilizing
          the services, your beneficial funds may be held at First Federal Bank
          of Kansas City, Member FDIC, in an omnibus custodial account.
        </p>
        <p className="mt-6 text-sm leading-8 text-gray-600">
          © {new Date().getFullYear()} New World Savings, Inc. dba Guac. All Rights Reserved.
        </p>
      </div>
    </>
  );
};
